import { render, staticRenderFns } from "./cityCorporation.vue?vue&type=template&id=e89c3a04"
import script from "./cityCorporation.vue?vue&type=script&lang=js"
export * from "./cityCorporation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports